import { service, baseURL, base, appName, localStorageAdapter, } from './app.service';
import LocationModel from '@/models/LocationModel';
import EventBus from '@EventBus';
import { map } from 'lodash';
var locationEndpoints = {
    GET_ALL_LOCATIONS: baseURL + "/admin/squib_search?app=" + appName + "&osl=1",
    GET_LOCATION_MAP: function (handle) {
        return baseURL + "/admin/squib_base_from_location_name?l=" + handle;
    },
};
var locationKey = 'location';
var locationService = {
    getLocationFromHandle: function (handle, callback) {
        var serviceCall = service.get(locationEndpoints.GET_LOCATION_MAP(handle));
        serviceCall.then(function (response) {
            var data = response.data;
            var body = data.body;
            var message = data.message;
            var normalizedResponse = {
                message: message,
                base: body.base,
            };
            callback(normalizedResponse);
        });
    },
    getLocations: function () {
        return service.get(locationEndpoints.GET_ALL_LOCATIONS).catch(function (reason) {
            console.error(reason);
            EventBus.$emit('display-network-failure', 'There was an error retrieving store locations.');
        });
    },
    getSingleLocation: function (base) {
        var endpoint = "/admin/squib_get_location?b=" + base + "&olo=true";
        return service.get(endpoint).then(function (res) {
            var data = res.data;
            var body = data.body;
            var rawLocation = body.location;
            return new LocationModel(rawLocation);
        });
    },
    base: base,
    setLocationForStorage: function (location) {
        localStorageAdapter.setItem(locationKey, location);
    },
    getLocationFromStorage: function () {
        var location = localStorageAdapter.getItem(locationKey);
        return location;
    },
    getLocationDetail: function (location) {
        var locality = location.getLocality();
        var name = location.name + " | " + locality;
        var todayHours = location.getTodayHours();
        var weekHours = location.getWeekHours();
        var locationId = location.id;
        var locationUrl = baseURL.replace("://c1.", "://" + location.pushHost + ".");
        var imageUrl = location.locationImageUrl;
        var hasImage = (imageUrl) ? imageUrl.indexOf('no-profile') === -1 : false;
        var locationImageUrl = (hasImage) ? "" + locationUrl + imageUrl : null;
        var isOpen = location.onlineStoreOpen;
        var closedMessage = location.onlineStoreClosedMessage;
        return {
            name: name,
            todayHours: todayHours,
            address: location.addressComponents,
            phone: location.contactPhone,
            openHours: weekHours,
            locationId: locationId,
            locationImageUrl: locationImageUrl,
            isOpen: isOpen,
            closedMessage: closedMessage,
        };
    },
    // Return value should be location detail model
    convertToLocationDetails: function (rawLocations) {
        var locationDetails = map(rawLocations, function (rawLocation) {
            var location = new LocationModel(rawLocation);
            return locationService.getLocationDetail(location);
        });
        return locationDetails;
    },
    isLocationType: function (location) {
        if (location instanceof LocationModel) {
            return true;
        }
        return false;
    }
};
export default locationService;



//////////////////
// WEBPACK FOOTER
// ./src/services/location.service.ts
// module id = SQlB
// module chunks = 18